import React from "react";
import update from "immutability-helper";
import { Row, SaveTable } from "./DataTable.jsx";

import { getAccount, saveAccount } from "./store/auth/AuthActions.js";

export default class Account extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            err: null,
            isUpdating: false,
            isDirty: false,
            loaded: false,
            data: {}
        }
        this.loadAccountInformation();
    }
    render() {
        return <div className="container">
            {this.state.err ?
                <div style={{ margin: "auto", width: "50%", textAlign: "center" }} id="no-devices" className="alert alert-danger" role="alert">
                    <p>{this.state.err}</p>
                </div>
                : 
                null
            }
            {this.state.loaded && !this.state.isUpdating ? this.renderForm() : this.renderLoading()}
        </div>
    }

    loadAccountInformation() {
        getAccount().then(data => {
            this.setState({ loaded: true, data: data })
        })
    }
    saveAccountInfo() {
        this.setState({ isUpdating: true });
        saveAccount(this.state.data).then(data => {
            this.setState({ isUpdating: false, err: data.err, isDirty: !!data.err });
        })
    }
    renderForm() {
        let bind = key => ({ value: this.state.data[key], onChange: ev => this.setState(update(this.state, { isDirty: { $set: true }, data: { [key]: { $set: ev.target.value } } })) })
        return <SaveTable disabled={!this.state.isDirty} onSave={() => this.saveAccountInfo()}>
            <Row label="Email"><input required className="form-control" type="email" placeholder="bob@example.com" {...bind("email") } /></Row>
            <Row label="Name"><input required className="form-control" type="test" placeholder="Bob" {...bind("name") } /></Row>
            <Row label="Company"><input className="form-control" type="company" placeholder="Bob's alarms" {...bind("company") } /></Row>
            <Row label="Phone number"><input className="form-control" type="tel" placeholder="0123456789" {...bind("telephone") } /></Row>
        </SaveTable>
    }

    renderLoading() {
        return <div style={{ margin: "auto", width: "50%", textAlign: "center" }} id="no-devices" className="alert alert-info" role="alert">
            <i className="fa fa-spinner fa-pulse"></i> {this.state.isUpdating ? "Updating" : "Loading"} account information.
        </div>
    }
}